<template>
  <div>
    <v-container grid-list-xl class="word-wrap mt-5">
      <v-layout row wrap justify-center mt-5 pb-5>
        <v-flex xs12 md8>
          <v-card class="defaultCardClass" flat>
            <v-card-title class="text-center py-6 px-6">
              <h5 class="font-weight-regular">
                {{ $t("description.bestOfDescription") }}
              </h5>
            </v-card-title>

            <v-tabs v-model="tab" background-color="transparent" grow color="defaultColor" style="border-bottom: 1px solid grey !important">
              <v-tab v-for="tabItem in tabItems" :key="tabItem.data">
                {{ tabItem.title }}
              </v-tab>
            </v-tabs>

            <v-tabs-items
              v-model="tab"
              style="overflow-y: scroll; height: calc(100vh - 290px)"
            >
              <v-tab-item v-for="tabItem in tabItems" :key="tabItem.data">
                <loading-progress :status="loadingList[tabItem.data]" />
                <v-list
                  subheader
                  two-line
                  style="background-color: transparent !important"
                >
                  <div
                    v-for="(item, index) in data[tabItem.data]"
                    :key="item.Id.concat(index.toString())"
                  >
                    <user-list-item
                      :item="item"
                      :avatar="item.Avatar"
                      :fullName="item.FirstName"
                      :department="item.Department"
                      :company="item.Company"
                      :noBg="true"
                      :userId="item.Id"
                      :divider="
                        data[tabItem.data].length == index + 1 ? false : true
                      "
                      :star="5 - index"
                    />
                  </div>
                </v-list>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import ContentService from "@/services/ContentService";
import UserListItem from "../../components/Users/UserListItem.vue";
import LoadingProgress from "../../components/General/LoadingProgress.vue";

export default {
  data: function () {
    {
      return {
        tab: null,

        tabItems: [
          { title: this.$t("tabs.bestOfPost"), data: "bestOfPostsData" },
          { title: this.$t("tabs.bestOfComment"), data: "bestOfCommentsData" },
          { title: this.$t("tabs.bestOfLike"), data: "bestOfLikesData" },
        ],

        data: {
          bestOfPostsData: [],
          bestOfCommentsData: [],
          bestOfLikesData: [],
        },

        loadingList: {
          bestOfPostsData: false,
          bestOfCommentsData: false,
          bestOfLikesData: false,
        },
      };
    }
  },
  components: {
    UserListItem,
    LoadingProgress,
  },
  methods: {
    getBestOf(type) {
      this.setLoading(type, true);
      ContentService.getBestOf(type)
        .then((res) => {
          switch (type) {
            case "post":
              this.data.bestOfPostsData = res.data.Result;
              break;
            case "comment":
              this.data.bestOfCommentsData = res.data.Result;
              break;
            case "like":
              this.data.bestOfLikesData = res.data.Result;
              break;
          }
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
          this.setLoading(type, false);
        });
    },

    setLoading(type, status) {
      switch (type) {
        case "post":
          this.loadingList.bestOfPostsData = status;
          break;
        case "comment":
          this.loadingList.bestOfCommentsData = status;
          break;
        case "like":
          this.loadingList.bestOfLikesData = status;
          break;
      }
    },
  },
  computed: {},
  destroyed() {},
  mounted() {
    this.getBestOf("post");
    this.getBestOf("comment");
    this.getBestOf("like");
  },
  watch: {},
};
</script>
